// authencation.ts
import { apiClient } from './axios';
export interface LoginSuccessResponse {
  accessToken: string;
  refreshToken: string;
}

export interface LoginErrorResponse {
  code: string;
  message: string;
}

export interface ProfileSuccessResponse {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  credit: number;
}

export const login = async (email: string, password: string): Promise<LoginSuccessResponse> => {
  const response = await apiClient.post<LoginSuccessResponse, LoginErrorResponse>('login', { email, password });
  if (response.error) {
    throw new Error(response.error.message);
  }
  if (response.data) {
    return response.data;
  }
  throw new Error('No data returned from login');
};

//me
export const me = async (): Promise<ProfileSuccessResponse> => {
  const response = await apiClient.get<ProfileSuccessResponse>('me');
  if (response.error) {
    throw new Error(response.error.message);
  }
  return response.data as ProfileSuccessResponse;
};

// Interface for profile update
interface UpdateProfileRequest {
  firstName: string;
  lastName: string;
}

// Function to update profile
export const updateProfile = async (
  data: UpdateProfileRequest
): Promise<ProfileSuccessResponse> => {
  const response = await apiClient.put<ProfileSuccessResponse>('me', data);
  if (response.error) {
    throw new Error(response.error.message || 'Failed to update profile');
  }
  return response.data as ProfileSuccessResponse;
};

interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

//change password
export const changePassword = async (data: ChangePasswordRequest): Promise<void> => {
  const response = await apiClient.put<void>('me/change-password', data);
  if (response.error) {
    throw new Error(response.error.message || 'Failed to change password');
  }
};

interface RegisterRequest {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
}

export const register = async (data: RegisterRequest): Promise<void> => {
  const response = await apiClient.post<void>('verify-email', data);
  if (response.error) {
    throw new Error(response.error.message || 'Failed to register');
  }
};

// Add these new interfaces and functions
interface SendOTPRequest {
  email: string;
}

interface VerifyOTPRequest {
  email: string;
  otpCode: string;
}

interface ResetPasswordRequest {
  email: string;
  resetPasswordToken: string;
  newPassword: string;
}

export const sendOTP = async (data: SendOTPRequest): Promise<void> => {
  const response = await apiClient.post<void>('forgot-password', data);
  if (response.error) {
    throw new Error(response.error.message || 'Failed to send OTP');
  }
};

export const verifyOTP = async (data: VerifyOTPRequest): Promise<string> => {
  const response = await apiClient.post<{ resetPasswordToken: string }>(
    'verify-forgot-password-token',
    data
  );
  if (response.error) {
    throw new Error(response.error.message || 'Invalid OTP');
  }
  return response.data?.resetPasswordToken || '';
};

export const resetPassword = async (data: ResetPasswordRequest): Promise<void> => {
  const response = await apiClient.post<void>('reset-password', data);
  if (response.error) {
    throw new Error(response.error.message || 'Failed to reset password');
  }
};

export const deleteAccount = async (): Promise<void> => {
  const response = await apiClient.delete<void>('me');
  if (response.error) {
    throw new Error(response.error.message || 'Failed to delete account');
  }
};

export interface SendVerificationEmailRequest {
  email: string;
  firstName: string;
}

//send-verification-email
export const sendVerificationEmail = async (data: SendVerificationEmailRequest): Promise<string> => {
  const response = await apiClient.post<{ message: string }>(
    'send-verification-email',
    data
  );
  if (response.error) {
    throw new Error(response.error.message || 'Failed to send verification email');
  }
  return response.data?.message || '';
};

///auth/google  
export const authGoogle = async (accessToken: string): Promise<LoginSuccessResponse> => {
  const response = await apiClient.post<LoginSuccessResponse, LoginErrorResponse>('auth/google', { idToken: accessToken });
  if (response.error) {
    throw new Error(response.error.message || 'Failed to authenticate with Google');
  }
  return response.data as LoginSuccessResponse;
};

///auth/apple
export const authApple = async (idToken: string, firstName?: string, lastName?: string): Promise<LoginSuccessResponse> => {
  const response = await apiClient.post<LoginSuccessResponse, LoginErrorResponse>('auth/apple', { 
    idToken, 
    firstName, 
    lastName 
  });
  if (response.error) {
    throw new Error(response.error.message || 'Failed to authenticate with Apple');
  }
  return response.data as LoginSuccessResponse;
};


